<template>
  <div class="max-w-full">
    <div
      class="mt-8 w-[356px] max-w-full aspect-square bg-white rounded-[8px] border border-gray-200 shadow-sm p-5 mx-auto flex items-center justify-center"
    >
      <canvas
        ref="qrCanvas"
        class="w-[311px] max-w-full !h-auto"
        :class="{ 'opacity-50': expired }"
      />
    </div>
    <div class="mt-4 flex flex-row items-center justify-center gap-2">
      <span
        class="material-symbols-outlined text-[24px] text-gray-500 ltr:mr-1 rtl:ml-1"
      >
        info
      </span>
      <span class="text-base leading-6 text-[#000]">
        {{ $t('INTEGRATION_SETTINGS.MOBILE_APP.EXPIRES_IN') }}
      </span>
      <span class="text-base leading-6 font-bold text-[#000]">
        {{ formattedTime }}
      </span>
    </div>
    <div class="mt-2 flex flex-row justify-center">
      <button-v2
        variant="naked"
        icon="replay"
        icon-class="-scale-x-100"
        class="!text-base !px-3"
        @click="generateQRCode"
      >
        {{ $t('INTEGRATION_SETTINGS.MOBILE_APP.REFRESH') }}
      </button-v2>
    </div>
  </div>
</template>

<script>
import QRCode from 'qrcode';
import alertMixin from 'shared/mixins/alertMixin';
import authAPI from '../../../../../../api/auth';

const QR_CODE_TTL = 600;

export default {
  name: 'QrCodeGenerator',
  mixins: [alertMixin],
  data() {
    return {
      expiresIn: QR_CODE_TTL,
      expired: false,
      timer: null,
    };
  },
  computed: {
    formattedTime() {
      const minutes = Math.floor(this.expiresIn / 60);
      const seconds = this.expiresIn % 60;
      return `${String(minutes).padStart(2, '0')}:${String(seconds).padStart(
        2,
        '0'
      )}`;
    },
  },
  mounted() {
    this.generateQRCode();
  },
  beforeDestroy() {
    this.isDestroyed = true;
    this.clearCountdown();
  },
  methods: {
    clearCountdown() {
      if (this.timer) {
        clearInterval(this.timer);
        this.timer = null;
      }
    },
    expire() {
      this.expiresIn = 0;
      this.expired = true;
      this.clearCountdown();
    },
    startCountdown() {
      this.clearCountdown();
      this.expired = false;
      this.expiresIn = QR_CODE_TTL;
      this.timer = setInterval(() => {
        this.expiresIn -= 1;
        if (this.expiresIn <= 0) this.expire();
      }, 1000);
    },
    async generateQRCode() {
      try {
        const response = await authAPI.getQrCode();
        if (this.isDestroyed) return;
        await QRCode.toCanvas(this.$refs.qrCanvas, response.data.qr_code, {
          width: 311,
          margin: 0,
        });
        if (this.isDestroyed) return;
        this.startCountdown();
      } catch (error) {
        if (this.isDestroyed) return;
        this.expire();
        this.showAlert(this.$t('INTEGRATION_SETTINGS.API_ERROR_MESSAGE'));
      }
    },
  },
};
</script>
